import { BrowserRouter, Route, Routes } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";

import Login from "../pages/login/Login";
import Dashboard from "../pages/dashboard/Dashboard";
import SubAdminDashboard from "../pages/dashboard/SubAdminDashboard";
import MemberList from "../pages/members/view_member/MemberList";
import ViewPaidMember from "../pages/members/view_paid_members/ViewPaidMember";
import MemberEnquiry from "../pages/members/member_enquiry/MemberEnquiry";

import Religion from "../pages/attribute/religion/Religion";
import Cast from "../pages/attribute/cast/Cast";
import SubCast from "../pages/attribute/sub_cast/SubCast";

import Country from "../pages/attribute/country/Country";
import State from "../pages/attribute/state/State";
import City from "../pages/attribute/city/City";

import Gotra from "../pages/attribute/gotra/Gotra";
import Language from "../pages/attribute/language/Language";
import Occupation from "../pages/attribute/occupation/Occupation";
import Hobbies from "../pages/attribute/hobbies/Hobbies";
import AddStaff from "../pages/staff/add_staff/AddStaff";
import ViewStaff from "../pages/staff/view_staff/ViewStaff";
import ViewLead from "../pages/view_leads/ViewLead";
import AddPlan from "../pages/membership_plans/add_plan/AddPlan";
import ViewPlan from "../pages/membership_plans/view_plan/ViewPlan";
import AddCoupon from "../pages/coupon/add_coupon/AddCoupon";
import ViewCoupon from "../pages/coupon/view_coupon/ViewCoupon";
import TransactionHistory from "../pages/transaction_history/TransactionHistory";
import AddTestimonials from "../pages/testimonials/add_testimnials/AddTestimonial";
import ViewTestimonials from "../pages/testimonials/view_testimonials/ViewTestimonials";
import Faq from "../pages/faq_help/Faq";
import Feedback from "../pages/feedback/Feedback";
import Disclaimer from "../pages/disclaimer/Disclaimer";
import PrivacyPolicy from "../pages/privacy_policy/PrivacyPolicy";
import TermsCondition from "../pages/terms_conditions/TermsCondition";
import Logout from "../pages/logout/Logout";
import WorkingWith from "../pages/attribute/workingwith/WorkingWith";
import Education from "../pages/attribute/education/Education";
import ProfessionalEducation from "../pages/attribute/professioaleducation/ProfessionalEducation";
import AddAgent from "../pages/agent/AddAgent";
import ViewAgent from "../pages/agent/ViewAgent";
import AgentPayNow from "../pages/agent/AgentPayNow";
import BulkEmail from "../pages/user_management/BulkEmail";
import BulkSMS from "../pages/user_management/BulkSMS";
import ProfileApproval from "../pages/profile_management/ProfileApproval";
import PhotoApproval from "../pages/profile_management/PhotoApproval";
import ProfileDocumentApproval from "../pages/profile_management/ProfileDocumentApproval";
import ViewMemberDetails from "../pages/members/view_member/ViewMemberDetails";
import EditMemberDetails from "../pages/members/view_member/EditMemberDetails";
import RenewMemberList from "../pages/membership_plans/renew/RenewMemberList";
import Notification from "../pages/notification/Notification";
import ProfilePromotion from "../pages/profile_promotion/ProfilePromotion";
import EnquiryList from "../pages/cutomer-support/EnquiryList";
import ReportedChat from "../pages/cutomer-support/ReportedChat";
import Blog from "../pages/blog/Blog";
import Homepage from "../pages/cms/Homepage";
import AboutUs from "../pages/cms/AboutUs";
import ExportData from "../pages/cms/ExportData";
import NumberStatsCMS from "../pages/cms/NumberStatsCMS";
import CMSHomePage from "../pages/cms/pages/CMSHomePage";
import CMSStateHomePage from "../pages/cms/pages/CMSStateHomePage";
import CMSBiharCityPage from "../pages/cms/pages/CMSBiharCityPage";
import CMSReligionPage from "../pages/cms/pages/CMSReligionPage";
import CMSCastePage from "../pages/cms/pages/CMSCastePage";
import AddSubAdmin from "../pages/role_permission/AddSubAdmin";
import ViewSubAdmin from "../pages/role_permission/ViewSubAdmin";
import ViewPermission from "../pages/role_permission/ViewPermission";
import EditPlan from "../pages/membership_plans/view_plan/EditPlan";
import MmCompatibuility from "../pages/attribute/mm_compatibuility/MmCompatibuility";
import ViewApprovalLead from "../pages/view_leads/ViewApprovalLead";
import MemberLoginHistory from "../pages/members/MemberLoginHistory";
import MemberLoginOtp from "../pages/role_permission/MemberLoginOtp";
import AdminMemberLoginHistory from "../pages/members/AdminMemberLoginHistory";

export default function Router() {
  const basename = window.location.pathname.startsWith("/admin") ? "/admin" : "/";
  return (
    <BrowserRouter basename={basename}>
      <Routes>
        {/* Public route */}
        <Route path="/" element={<Login />} />

        {/* Protected admin routes */}
        <Route
          path="/dashboard"
          element={<PrivateRoute><Dashboard /></PrivateRoute>}
        />
        <Route
          path="/sub-admin-dashboard"
          element={<PrivateRoute><SubAdminDashboard /></PrivateRoute>}
        />
        <Route
          path="/members/new-member"
          element={<PrivateRoute><MemberList /></PrivateRoute>}
        />
        <Route
          path="/user/all-member"
          element={<PrivateRoute><MemberList /></PrivateRoute>}
        />
        <Route
          path="/user/view-member/:id"
          element={<PrivateRoute><ViewMemberDetails /></PrivateRoute>}
        />
        <Route
          path="/user/edit-member/:id"
          element={<PrivateRoute><EditMemberDetails /></PrivateRoute>}
        />
        <Route
          path="/user/paid-member"
          element={<PrivateRoute><MemberList /></PrivateRoute>}
        />
        <Route
          path="/user/deleted-member"
          element={<PrivateRoute><MemberList /></PrivateRoute>}
        />
        <Route
          path="/user/member-enquiry"
          element={<PrivateRoute><MemberEnquiry /></PrivateRoute>}
        />
        <Route
          path="/user/bulk-email"
          element={<PrivateRoute><BulkEmail /></PrivateRoute>}
        />
        <Route
          path="/user/bulk-sms"
          element={<PrivateRoute><BulkSMS /></PrivateRoute>}
        />
        <Route
          path="/profile/profile-approval"
          element={<PrivateRoute><ProfileApproval /></PrivateRoute>}
        />
        <Route
          path="/profile/photo-approval"
          element={<PrivateRoute><PhotoApproval /></PrivateRoute>}
        />
        <Route
          path="/profile/document-approval"
          element={<PrivateRoute><ProfileDocumentApproval /></PrivateRoute>}
        />
        <Route
          path="/agent/add-agent"
          element={<PrivateRoute><AddAgent /></PrivateRoute>}
        />
        <Route
          path="/agent/edit-agent/:agentId"
          element={<PrivateRoute><AddAgent /></PrivateRoute>}
        />
        <Route
          path="/agent/view-agent"
          element={<PrivateRoute><ViewAgent /></PrivateRoute>}
        />
        <Route
          path="/agent/view-leads"
          element={<PrivateRoute><ViewAgent /></PrivateRoute>}
        />
        <Route
          path="/agent/view-leads/:agentId"
          element={<PrivateRoute><ViewLead /></PrivateRoute>}
        />
        <Route
          path="/agent/pending-approval-leads/:agentId"
          element={<PrivateRoute><ViewApprovalLead /></PrivateRoute>}
        />
        <Route
          path="/agent/pay-commission/:agentId"
          element={<PrivateRoute><AgentPayNow /></PrivateRoute>}
        />
        <Route
          path="/attribute/country"
          element={<PrivateRoute><Country /></PrivateRoute>}
        />
        <Route
          path="/attribute/state"
          element={<PrivateRoute><State /></PrivateRoute>}
        />
        <Route
          path="/attribute/city"
          element={<PrivateRoute><City /></PrivateRoute>}
        />
        <Route
          path="/attribute/religion"
          element={<PrivateRoute><Religion /></PrivateRoute>}
        />
        <Route
          path="/attribute/cast"
          element={<PrivateRoute><Cast /></PrivateRoute>}
        />
        <Route
          path="/attribute/sub-cast"
          element={<PrivateRoute><SubCast /></PrivateRoute>}
        />
        <Route
          path="/attribute/gotra"
          element={<PrivateRoute><Gotra /></PrivateRoute>}
        />
        <Route
          path="/attribute/language"
          element={<PrivateRoute><Language /></PrivateRoute>}
        />
        <Route
          path="/attribute/occupation"
          element={<PrivateRoute><Occupation /></PrivateRoute>}
        />
        <Route
          path="/attribute/hobbies"
          element={<PrivateRoute><Hobbies /></PrivateRoute>}
        />
        <Route
          path="/attribute/working-with"
          element={<PrivateRoute><WorkingWith /></PrivateRoute>}
        />
        <Route
          path="/attribute/education"
          element={<PrivateRoute><Education /></PrivateRoute>}
        />
        <Route
          path="/attribute/professional-education"
          element={<PrivateRoute><ProfessionalEducation /></PrivateRoute>}
        />
        <Route
          path="/attribute/mm-compatibuility"
          element={<PrivateRoute><MmCompatibuility /></PrivateRoute>}
        />
        <Route
          path="/staff/add-staff"
          element={<PrivateRoute><AddStaff /></PrivateRoute>}
        />
        <Route
          path="/staff/view-staff"
          element={<PrivateRoute><ViewStaff /></PrivateRoute>}
        />
        <Route
          path="/view-lead"
          element={<PrivateRoute><ViewLead /></PrivateRoute>}
        />
        <Route
          path="/membership-plans/add-plan"
          element={<PrivateRoute><AddPlan /></PrivateRoute>}
        />
        <Route
          path="/membership/view-plan"
          element={<PrivateRoute><ViewPlan /></PrivateRoute>}
        />
        <Route
          path="/membership/edit-plan/:planId"
          element={<PrivateRoute><EditPlan /></PrivateRoute>}
        />
        <Route
          path="/membership/add-coupon"
          element={<PrivateRoute><AddCoupon /></PrivateRoute>}
        />
        <Route
          path="/membership/renew-member-list"
          element={<PrivateRoute><RenewMemberList /></PrivateRoute>}
        />
        <Route
          path="/notification"
          element={<PrivateRoute><Notification /></PrivateRoute>}
        />

        <Route
          path="/profile-promotion"
          element={<PrivateRoute><ProfilePromotion /></PrivateRoute>}
        />

        <Route
          path="/coupon/view-coupon"
          element={<PrivateRoute><ViewCoupon /></PrivateRoute>}
        />
        <Route
          path="/transaction-history"
          element={<PrivateRoute><TransactionHistory /></PrivateRoute>}
        />
        <Route
          path="/testimonials/add-testimonials"
          element={<PrivateRoute><AddTestimonials /></PrivateRoute>}
        />
        <Route
          path="/testimonials/edit-testimonial/:id"
          element={<PrivateRoute><AddTestimonials /></PrivateRoute>}
        />
        <Route
          path="/testimonials/view-testimonials"
          element={<PrivateRoute><ViewTestimonials /></PrivateRoute>}
        />
        <Route
          path="/customer-support/enquiry-list"
          element={<PrivateRoute><EnquiryList /></PrivateRoute>}
        />
        <Route
          path="/customer-support/reported-chat"
          element={<PrivateRoute><ReportedChat /></PrivateRoute>}
        />
        <Route
          path="/blog"
          element={<PrivateRoute><Blog /></PrivateRoute>}
        />
        
         <Route
          path="/cms/homepage"
          element={<PrivateRoute><Homepage /></PrivateRoute>}
        />
        

        <Route
          path="/cms/faq"
          element={<PrivateRoute><Faq /></PrivateRoute>}
        />
        <Route
          path="/cms/feedback"
          element={<PrivateRoute><Feedback /></PrivateRoute>}
        />
        <Route
          path="/cms/disclaimer"
          element={<PrivateRoute><Disclaimer /></PrivateRoute>}
        />
        <Route
          path="/cms/privacy-policy"
          element={<PrivateRoute><PrivacyPolicy /></PrivateRoute>}
        />
        <Route
          path="/cms/terms-condition"
          element={<PrivateRoute><TermsCondition /></PrivateRoute>}
        />
        <Route
          path="/cms/about"
          element={<PrivateRoute><AboutUs /></PrivateRoute>}
        />
        <Route
          path="/cms/export-data"
          element={<PrivateRoute><ExportData /></PrivateRoute>}
        />
        <Route
          path="/cms/number-stats"
          element={<PrivateRoute><NumberStatsCMS /></PrivateRoute>}
        />
        <Route
          path="/cms/page-home"
          element={<PrivateRoute><CMSHomePage /></PrivateRoute>}
        />
        <Route
          path="/cms/page-state"
          element={<PrivateRoute><CMSStateHomePage /></PrivateRoute>}
        />
        <Route
          path="/cms/page-bihar-city"
          element={<PrivateRoute><CMSBiharCityPage /></PrivateRoute>}
        />
        <Route
          path="/cms/page-religion"
          element={<PrivateRoute><CMSReligionPage /></PrivateRoute>}
        />
        <Route
          path="/cms/page-caste"
          element={<PrivateRoute><CMSCastePage /></PrivateRoute>}
        />

        <Route
          path="/roles-permissions/add-subadmin"
          element={<PrivateRoute><AddSubAdmin /></PrivateRoute>}
        />
        <Route
          path="/roles-permissions/update/:id"
          element={<PrivateRoute><AddSubAdmin /></PrivateRoute>}
        />
        <Route
          path="/roles-permissions/view-subadmin"
          element={<PrivateRoute><ViewSubAdmin /></PrivateRoute>}
        />
        <Route
          path="/roles-permissions/member-common-login-otp"
          element={<PrivateRoute><MemberLoginOtp /></PrivateRoute>}
        />
        <Route
          path="/roles-permissions/staff-member-login"
          element={<PrivateRoute><AdminMemberLoginHistory /></PrivateRoute>}
        />

        <Route
          path="/roles-permissions/view-permission/:id"
          element={<PrivateRoute><ViewPermission  /></PrivateRoute>}
        />

        <Route
          path="/logout"
          element={<PrivateRoute><Logout /></PrivateRoute>}
        />

        <Route
          path="/user/login-history/:profile_id?"
          element={<PrivateRoute><MemberLoginHistory /></PrivateRoute>}
        />
      </Routes>
    </BrowserRouter>
  );
}
